import wearMasks from "../assets/img/wear-masks.svg";
import washYourHands from "../assets/img/wash-your-hands.svg";
import useNoseRag from "../assets/img/use-nose-rag.svg";
import avoidContacts from "../assets/img/avoid-contacts.svg";

export default [
  {
    title: "Wear Masks",
    image: wearMasks,
    description:
      'Continually seize impactful vortals rather than future-proof supply chains. Uniquely exploit emerging niches via fully tested meta-services. Competently pursue standards compliant leadership skills vis-a-vis pandemic "outside the box" thinking. Objectively',
  },
  {
    title: "Wash Your Hands",
    image: washYourHands,
    description:
      'Continually seize impactful vortals rather than future-proof supply chains. Uniquely exploit emerging niches via fully tested meta-services. Competently pursue standards compliant leadership skills vis-a-vis pandemic "outside the box" thinking. Objectively Continually seize impactful vortals ',
  },
  {
    title: "Use nose - rag",
    image: useNoseRag,
    description:
      'Continually seize impactful vortals rather than future-proof supply chains. Uniquely exploit emerging niches via fully tested meta-services. Competently pursue standards compliant leadership skills vis-a-vis pandemic "outside the box" thinking. Objectively ',
  },
  {
    title: "Avoid contacts",
    image: avoidContacts,
    description:
      "Continually seize impactful vortals rather than future-proof supply chains. Uniquely exploit emerging niches via fully tested meta-services. Competently pursue standards compliant leadership skills vis-a-vis pandemic",
  },
];
